import gql from 'graphql-tag'

export const GET_ORGANIZATION = gql`
  query getOrganization($organizationSlug: String!) {
    getOrganization(organizationSlug: $organizationSlug) {
      id
      publicName
      legalName
      logo
      description
      facebookLink
      instagramLink
      webLink
      email
      address
      city
      postalCode
      OIB
      IBAN
      VATObligor
      VATPercentage
      preferredLanguage
      liveEventsCount
      type
      authorizedPerson
      primaryEmail
      contactNumber
      events {
        to
      }
      userOrganization {
        role
      }
    }
  }
`
export const GET_ORGANIZATION_BY_SLUG = gql`
  query getOrganizationBySlug($organizationSlug: String!) {
    getOrganizationBySlug(organizationSlug: $organizationSlug) {
      id
      publicName
      legalName
      logo
      description
      facebookLink
      instagramLink
      webLink
      email
      address
      city
      postalCode
      OIB
      IBAN
      VATObligor
      VATPercentage
      preferredLanguage
      type
      imageUrls
      attendeeFields
      slug
    }
  }
`

export const GET_ORGANIZATIONS = gql`
  query getOrganizations {
    getOrganizations {
      id
      publicName
      legalName
      slug
      logo
      description
      type
      facebookLink
      instagramLink
      webLink
      email
      address
      city
      postalCode
      OIB
      IBAN
      VATObligor
      userOrganization {
        default
      }
      preferredLanguage
      liveEventsCount
    }
  }
`

export const CHECK_FOR_ORGANIZATION_WITH_SAME_FINANCE_INFO = gql`
  query checkIfOrganizationWithSameFinanceInfoExists($oib: String!) {
    checkIfOrganizationWithSameFinanceInfoExists(oib: $oib)
  }
`

export const CREATE_ORGANIZATION = gql`
  mutation createOrganization($organizationInfo: CreateOrganizationInput!) {
    createOrganization(organizationInfo: $organizationInfo) {
      publicName
      slug
      logo
      type
    }
  }
`

export const UPDATE_ORGANIZATION = gql`
  mutation updateOrganization($organizationId: Int!, $organizationInfo: UpdateOrganizationInput!) {
    updateOrganization(organizationId: $organizationId, organizationInfo: $organizationInfo)
  }
`

export const DELETE_ORGANIZATION = gql`
  mutation deleteOrganization($organizationSlug: String!, $organizationId: Int!) {
    deleteOrganization(organizationSlug: $organizationSlug, organizationId: $organizationId)
  }
`

export const GET_ORGANIZATION_USERS_AND_INVITES = gql`
  query getOrganizationUsersAndInvites($organizationSlug: String!) {
    getOrganizationUsers(organizationSlug: $organizationSlug) {
      id
      firstName
      lastName
      email
      organizationRole
    }
    getOrganizationInvites(organizationSlug: $organizationSlug) {
      id
      email
      organizationRole
      expired
    }
  }
`

export const UPDATE_IMAGE_URLS = gql`
  mutation UpdateImageUrls($organizationSlug: String!, $imageUrls: ImageUrls!) {
    updateImageUrls(organizationSlug: $organizationSlug, imageUrls: $imageUrls)
  }
`

export const GET_ORGANIZATION_ATTENDEE_FIELDS = gql`
  query GetOrganizationAttendeeFields($organizationSlug: String!) {
    getOrganizationBySlug(organizationSlug: $organizationSlug) {
      attendeeFields
      hasOrganizationPrepaidCouponUsers
      hasOrganizationMembershipUsers
    }
  }
`

export const UPDATE_ORGANIZATION_ATTENDEE_FIELDS = gql`
  mutation UpdateOrganizationAttendeeFields($organizationSlug: String!, $attendeeFields: JSON!) {
    updateOrganizationAttendeeFields(
      organizationSlug: $organizationSlug
      attendeeFields: $attendeeFields
    )
  }
`
